export const app = {
  data () {
    return {
    }
  },
  methods: {
    checkValue (item) {
      if (item === 'rabat') {
        if (this.outputData.rabat.value > 99) {
          this.outputData.rabat.value = 99
        }
        if (this.outputData.rabat.value < 0) {
          this.outputData.rabat.value = 0
        }
        this.changeOutputs('rabat')
      }
      if (item === 'dodatkowe_u') {
        if (this.inputData.dodatkowe_u.value > 40) {
          this.inputData.dodatkowe_u.value = 40
        }
        if (this.inputData.dodatkowe_u.value < 0) {
          this.inputData.dodatkowe_u.value = 0
        }
        this.changeInputs('dodatkowe_u')
      }
    },
    changeValueInputs (name, type, val) {
      this.$store.commit('app/UPDATED_INPUTS', {
        'name': name,
        'type': type,
        'val': val
      }, { root: false })
    },
    changeValueOutputs (name, type, val) {
      this.$store.commit('app/UPDATED_OUTPUTS', {
        'name': name,
        'type': type,
        'val': val
      }, { root: false })
    },
    changeValueConfig (name, type, val) {
      this.$store.commit('app/UPDATED_CONFIG', {
        'name': name,
        'type': type,
        'val': val
      }, { root: false })
    },
    changeInputs (event) {
      if (this.inputData[event].value) {
        this.changeValueInputs(event, 'value', this.inputData[event].value)
        this.$store.commit('app/UPDATED_SELECTED_INPUT', event)
      }
      // this[event](this.inputData[event])
      this.changeOther(event)
    },
    changeOutputs (event) {
      if (this.outputData[event].value) {
        this.changeValueOutputs(event, 'value', this.outputData[event].value)
      }
      this.changeOther(event)
    },
    changeOther (labelName) {
      if (labelName === 'dodatkowe_u') {
        if (this.inputData[labelName].value > this.inputs[labelName].max) {
          this.changeValueInputs('dodatkowe_u', 'value', this.inputs[labelName].max)
        } else {
          this.changeValueInputs('dodatkowe_u', 'value', this.inputData[labelName].value)
        }
      }
      if (labelName === 'glebokosc_szafy') {
        this.changeValueInputs('glebokosc_szafy', 'active', true)
        this.changeValueInputs('glebokosc_szafy', 'value', Number(this.inputData.glebokosc_szafy.value))
        // console.log('zajmowaneOtw: ', this.inputData.glebokosc_szafy.value)
      }
      if (labelName === 'wzmacniacz') {
        this.changeValueInputs('wzmacniacz_rezerwowy', 'max', (this.inputData[labelName].max - this.inputData[labelName].value))

        this.changeValueInputs('sygnal_pilota', 'max', (1000 * this.inputData[labelName].value))
        this.changeValueInputs('sygnal_pilota', 'value', (1000 * this.inputData[labelName].value))
        this.changeValueInputs('moc_glosnikow', 'max', (1000 * this.inputData[labelName].value))
        this.changeValueInputs('moc_glosnikow', 'value', (1000 * this.inputData[labelName].value))
        this.changeValueInputs('moc_systemu', 'max', (1000 * this.inputData[labelName].value))
        this.changeValueInputs('moc_systemu', 'value', (1000 * this.inputData[labelName].value))

        if (this.inputData[labelName].value > 0) {
          this.changeValueInputs('sygnal_pilota_cb', 'value', true)
        } else {
          this.changeValueInputs('sygnal_pilota_cb', 'value', false)
          this.changeValueInputs('sygnal_pilota', 'value', 0)
        }
      }

      if (labelName === 'wzmacniacz_rezerwowy') {
        this.changeValueInputs('wzmacniacz', 'max', (this.inputData['wzmacniacz'].max - this.inputData[labelName].value))
      }

      if (labelName === 'wariant1') { // mikrofon w środku
        this.changeValueInputs('wariant1_rozszerzenia', 'max', (1 * this.inputData[labelName].value))

        if (this.inputData[labelName].value === 0 || this.inputData[labelName].value === '0') {
          this.changeValueInputs('wariant1_rozszerzenia', 'value', 0)
        }
      }

      if (labelName === 'wariant2') { // mikrofon poza
        this.changeValueInputs('wariant2_rozszerzenia', 'max', (5 * this.inputData[labelName].value))

        if (this.inputData[labelName].value === 0 || this.inputData[labelName].value === '0') {
          this.changeValueInputs('wariant2_rozszerzenia', 'value', 0)
        }
      }

      if (labelName === 'wariant3') { // mikrofon do 80
        this.changeValueInputs('wariant3_rozszerzenia', 'max', (2 * this.inputData[labelName].value))

        if (this.inputData[labelName].value === 0 || this.inputData[labelName].value === '0') {
          this.changeValueInputs('wariant3_rozszerzenia', 'value', 0)
        }
      }

      if (labelName === 'wariant4') { // mikrofon od 80
        this.changeValueInputs('wariant4_rozszerzenia', 'max', (2 * this.inputData[labelName].value))

        if (this.inputData[labelName].value === 0 || this.inputData[labelName].value === '0') {
          this.changeValueInputs('wariant4_rozszerzenia', 'value', 0)
        }
      }

      if (labelName === 'wariant5') { // mikrofon + adapter
        this.changeValueInputs('wariant5_rozszerzenia', 'max', (5 * this.inputData[labelName].value))

        if (this.inputData[labelName].value === 0 || this.inputData[labelName].value === '0') {
          this.changeValueInputs('wariant5_rozszerzenia', 'value', 0)
        }
      }

      if (labelName === 'obudowa_plytki') {
        this.changeValueInputs(labelName, 'value', this.inputData[labelName].value)
      // console.log(this.inputData[labelName].value)
      }
      if (labelName === 'panel_wentylacyjny') {
        this.changeValueInputs(labelName, 'value', this.inputData[labelName].value)
        // console.log(this.inputData[labelName].value)
      }
      if (labelName === 'kolka') {
        this.changeValueInputs(labelName, 'value', this.inputData[labelName].value)
        // console.log(this.inputData[labelName].value)
      }

      if (labelName === 'sygnal_pilota_cb') {
        this.changeValueInputs('sygnal_pilota_cb', 'value', this.inputData[labelName].value)
        if (!this.inputData[labelName].value) {
          this.changeValueInputs('sygnal_pilota', 'value', 0)
        }
      }
      if (labelName === 'sygnal_pilota') {
        this.changeValueInputs('sygnal_pilota', 'max', this.inputData['moc_glosnikow'].value)
        // parametrs_in_cd.ns_20kHz.maximum = parametrs_in_cd.ns_impedancja.value;
        // wartosc_do_dyspozycji - parametrs_in.ns_impedancja.value;
      }
      if (labelName === 'moc_glosnikow') {
        if (this.inputData['moc_glosnikow'].value < this.inputData['sygnal_pilota'].value) {
          this.changeValueInputs('sygnal_pilota', 'value', this.inputData['moc_glosnikow'].value)
        }
        this.changeValueInputs('sygnal_pilota', 'max', this.inputData['moc_glosnikow'].value)
        // parametrs_in_cd.ns_impedancja.maximum = wartosc_do_dyspozycji - parametrs_in_cd.ns_20kHz.value;
        // parametrs_in_cd.ns_20kHz.maximum = parametrs_in_cd.ns_impedancja.value;
        // wartosc_do_dyspozycji - parametrs_in_cd.ns_impedancja.value;
      }

      this.obliczenia_sprzetu()
    },

    check_depth_rack (wielkoscSzafy, aSzafy) {
      var aDepth = []
      aSzafy.filter(item => {
        if (item.attributes.wysokosc === wielkoscSzafy) {
          aDepth.push(item.attributes.glebokosc)
        }
      })
      // console.log('aDepth', aDepth)
      this.changeValueConfig('glebokosc', 'value', aDepth)
    },

    wzmacniacz (data) {
      // -> obliczenia_sprzetu();
      // products.dane_podst.ns_wzmacniacz_rez.maximum = products.dane_podst.ns_wzmacniacz.maximum - products.dane_podst.ns_wzmacniacz.value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/app.js